// extracted by mini-css-extract-plugin
export default {"failIcon":"AlreadyEnrolled_failIcon__re1N4","scale":"AlreadyEnrolled_scale__r8cwr","submitTwoFactor":"AlreadyEnrolled_submitTwoFactor__F+goc"};